import React, { useEffect, useState } from "react";
import styled from "styled-components";
import NewsletterForm from "./NewsletterForm";

// Mounted via wrapRootElement in gatsby-browser.js. Open via:
//   window.dispatchEvent(new CustomEvent("nl:open-signup"))
// NewsletterButton fires it on click.

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.78);
  /* Above XpToast (9999) so a gamification award firing mid-form doesn't
     paint over the input. */
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

const Panel = styled.div`
  background: var(--nd-black);
  border: 1px solid var(--nd-border-visible);
  border-radius: 12px;
  padding: 32px;
  max-width: 480px;
  width: 100%;
  max-height: 92vh;
  overflow-y: auto;
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const Kicker = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
`;

const CloseBtn = styled.button`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: transparent;
  color: var(--nd-text-secondary);
  border: 1px solid var(--nd-border-visible);
  border-radius: 999px;
  padding: 4px 12px;
  cursor: pointer;
  &:hover { color: var(--nd-text-display); }
`;

const Heading = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 28px;
  font-weight: 500;
  letter-spacing: -0.01em;
  color: var(--nd-text-display);
  margin: 0 0 8px;
  line-height: 1.15;
`;

const Sub = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: var(--nd-text-secondary);
  margin: 0 0 24px;
`;

const NewsletterModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const onOpen = () => setOpen(true);
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("nl:open-signup", onOpen);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("nl:open-signup", onOpen);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  if (!open) return null;

  return (
    <Overlay onClick={() => setOpen(false)} role="dialog" aria-modal="true">
      <Panel onClick={(e) => e.stopPropagation()}>
        <Head>
          <Kicker>NEWSLETTER · SIGN UP</Kicker>
          <CloseBtn type="button" onClick={() => setOpen(false)}>Close</CloseBtn>
        </Head>
        <Heading>One email a month.</Heading>
        <Sub>
          New labs, what broke in production, what we&apos;d build differently.
          Reply with &quot;unsubscribe&quot; any time.
        </Sub>
        <NewsletterForm compact />
      </Panel>
    </Overlay>
  );
};

export default NewsletterModal;
